import { useMutation } from "@tanstack/react-query";
import AxiosConfig from "./config/AxiosConfig";
import {useAuth} from "../components/auth/AuthContext";

const loginSoftcat = async (credentials) => {
    // const response = await AxiosConfig.post("/api/login", JSON.stringify(credentials), {
    //     headers: {
    //         "Content-Type": "application/json",
    //     },
    // });
    const response = await fetch("/api/login", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(credentials),
    });

    // if (!response.ok) {
    //     const errorData = await response.json();
    //     throw new Error(errorData.message || "로그인에 실패했습니다.");
    // }

    const data = await response.json();

    if (data) {
        // console.log("로그인 성공 : ", token, role);
        return data;
    } else {
        const errorData = await response.json();
        throw new Error(errorData.message || "로그인에 실패했습니다.");
    }

};

export const useLoginMutation = () => {
    const { login } = useAuth();

    return useMutation({
        mutationFn: loginSoftcat,


        onSuccess: (data) => {
            const token = data.data.token;
            const role = data.data.role;
            localStorage.setItem("token", token);
            localStorage.setItem("role", role);
            login(token, role);
            // console.log("로그인 성공(토큰): ", token);
            console.log("로그인 성공 : ", token, role);
        },
        onerror: (error) => {
            console.error("로그인 실패 : ", error);
        },
    });
};